import ElementController from "../base-controllers/ElementController.js";
/** Grow a textarea with its content while respecting its CSS max-height. */
class AutoGrowTextarea extends ElementController {
    constructor() {
        super(...arguments);
        this.resize = () => {
            const textarea = this.root;
            textarea.style.height = "auto";
            textarea.style.height = `${textarea.scrollHeight}px`;
        };
    }
    init() {
        this.resize();
    }
}
AutoGrowTextarea.id = "AutoGrowTextarea";
AutoGrowTextarea.binds = {
    root: [["input", "resize"]],
};
export default AutoGrowTextarea;
//# sourceMappingURL=AutoGrowTextarea.js.map